import styled from 'styled-components';

import { PULSE } from '../../../../theme/tokens';
import { pulseCard } from '../../../../theme/mixins';
import { Text } from '../../../../components';

/** Outer Pulse card — every section sits on the zinc card with a 10px gutter and
 *  stacks its header + content with the source's 10px gap. */
export const Card = styled.section`
  ${pulseCard}
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

/** Section header row (source `.metric-head` inside a `.pulse-section`) — inset
 *  5px to match the source's `px-[5px]` header padding. */
export const Head = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 0 5px;
`;

/** Title + optional muted suffix sit inline inside one heading. */
export const Heading = styled.h3`
  margin: 0;
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 18px;
  font-weight: 700;
  color: ${PULSE.t300};
`;

/** The suffix matches the title's size (18px) at 50% opacity — not a tiny note. */
export const Suffix = styled(Text)`
  font-size: 18px;
  font-weight: 400;
  color: ${PULSE.suffix};
`;
